module.exports = __webpack_public_path__ + "img/map1-blurred.860e864.png";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/map1-blurred.png
// module id = ./assets/loading/imgs/map1-blurred.png
// module chunks = 2 3 4 5 6 7 8